import React from 'react'
import moment from 'moment-timezone'

import './ChangeRecurrenceAliadaSearch.scss'

import ChangeAliadaSearchBase from 'components/ChangeAliadaSearchBase'
import { formatDate, pluralizedWeekday } from 'utils/dates'
import Loader from 'components/Loader'
import { TIMEZONE, recurrencePeriodicity } from '@src/globals'

import * as qs from 'utils/querystring'
import * as paths from 'utils/paths'

class ChangeRecurrenceAliadaSearch extends ChangeAliadaSearchBase {
  constructor () {
    super()

    this.navBarLabel = 'Modificar Recurrencia'
  }

  getNextWeekdayMoment (weekday) {
    const isoWeekday = moment().isoWeekday(weekday).isoWeekday()
    const now = moment.tz(Date.now(), TIMEZONE)
    const weekdayIsInTheFuture = isoWeekday > now.isoWeekday()

    if (weekdayIsInTheFuture) {
      return now.isoWeekday(isoWeekday)
    } else {
      return now.add(1, 'week').isoWeekday(isoWeekday)
    }
  }

  buildSearchQuerystring (data) {
    const nextWeekday = this.getNextWeekdayMoment(data.weekday)
    const recurrenceMoment = nextWeekday.hour(data.hour).minute(0)

    const queryobject = {
      date: formatDate('YYYY-MM-DD', recurrenceMoment),
      time: formatDate('HH:mm', recurrenceMoment),
      estimatedHours: data.estimatedHours,
      coordinates: {
        ...data.address.location
      },
      serviceTypeId: recurrencePeriodicity[data.periodicity].serviceTypeId,
      recurrenceId: data.id,
      sort: data.sort,
      userId: data.userId
    }

    return qs.stringify(queryobject)
  }

  renderFlashMessage (booking) {
    const recurrenceMoment = moment.tz(Date.now(0), TIMEZONE).day(booking.weekday).hour(booking.hour).minute(0)
    return (
      <div className='ChangeAliadaSearch-flashMessage'>
        <p className='ChangeAliadaSearch-flashMessageTitle'>
          Estas Aliadas están disponibles
        </p>
        <p className='ChangeAliadaSearch-flashMessageContent'>
          Para tu recurrencia de los <strong>{pluralizedWeekday(recurrenceMoment)} a las {formatDate('h:mm A', recurrenceMoment)}</strong>
        </p>
      </div>
    )
  }

  renderSearchResults ({searching, searchResults, resultsDisplayed, booking, userId}) {
    return (
      <div className='ChangeAliadaSearch-searchResults'>
        {searching
          ? <Loader text='Buscando' className='ChangeAliadaSearch-searchResultsLoader' />
          : searchResults
              .slice(0, resultsDisplayed)
              .map(aliada => {
                const aliadaProfileUrl = paths.replaceAliadaProfile(userId, aliada.id, recurrencePeriodicity[booking.periodicity].serviceTypeId, booking.id, booking.estimatedHours)
                const changeAliadaQueryobject = { replacement_aliada_id: aliada.id }
                const changeAliadaUrl = paths.recurrenceChangeAliadaConfirm(userId, booking.id, changeAliadaQueryobject)

                const props = {
                  booking,
                  aliada,
                  aliadaProfileUrl,
                  changeAliadaUrl
                }
                return this.renderResult(props)
              })
        }
      </div>
    )
  }
}

ChangeRecurrenceAliadaSearch.displayName = 'ChangeRecurrenceAliadaSearch'

export default ChangeRecurrenceAliadaSearch



// WEBPACK FOOTER //
// ./src/screens/App/screens/Recurrences/screens/ChangeRecurrenceAliadaSearch/ChangeRecurrenceAliadaSearch.js